export const documentHasH2 = (document: any) => {
  return document.content.some((node: any) => node.nodeType === "heading-2");
};
